import styled from 'styled-components'

import { Card } from '@/components/ui/card'
import { Typography } from '@/components/ui/typography'

export const TotalResponsesValue = styled(Typography)(() => ({
  fontSize: '4.2rem',
  lineHeight: '4.2rem',
}))

export const Container = styled(Card)(({ theme }) => ({
  flex: 'none',
  gap: theme.space['24'],
  height: 'auto',
}))

export const Header = styled.div(({ theme }) => ({
  borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray200}`,
  paddingBottom: theme.space['16'],
}))

export const ChartsGrid = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.space['24'],
}))

export const ChartItem = styled.div<{ $isSingle: boolean }>(({ theme, $isSingle }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flex: $isSingle ? '1' : `0 1 calc(50% - ${theme.space['12']})`,
  flexDirection: 'column',
  gap: theme.space['20'],
}))

export const ChartWrapper = styled.div(() => ({
  height: '28rem',
  position: 'relative',
  width: 'min(100%, 33rem)',
}))

export const Legend = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const LegendItem = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))

export const LegendDot = styled.span<{ $color: string }>(({ $color }) => ({
  backgroundColor: $color,
  flexShrink: 0,
  height: '1.2rem',
  width: '1.2rem',
}))

export const ChartRow = styled.div(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: theme.space['16'],
}))

export const CenterLabel = styled.div(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  inset: 0,
  justifyContent: 'center',
  pointerEvents: 'none',
  position: 'absolute',
  textAlign: 'center',
}))
